import { render, staticRenderFns } from "./showPolygonAndLocation.vue?vue&type=template&id=c0a02ae4&"
import script from "./showPolygonAndLocation.vue?vue&type=script&lang=js&"
export * from "./showPolygonAndLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports